import { createSelector } from '@lumapps/redux/reselect';

import { ProgramFormState } from './programForm/slice';
import { SAProgramState } from './types';

const internalSaProgramsSelector = (state: BaseStore): SAProgramState => state.saPrograms || {};

export const saProgramsSelector = createSelector(internalSaProgramsSelector, (saPrograms) => saPrograms);

export const programFormSelector = createSelector(
    saProgramsSelector,
    (saPrograms: SAProgramState): ProgramFormState => saPrograms.programForm,
);
